import { DataFilter } from './interface';
import { Not, StringListContains, StringListContainsAll } from '@vendasta/automata';
import { ConnectionsOptionsComponent } from './dynamic-options/connections-options/connections-options.component';
import { ConnectionsOptionsDisplayService } from './dynamic-options/connections-options/connections-options-display.service';

const CONNECTIONS = '{.connections}';
export class ConnectionsDataFilter implements DataFilter {
  rules = [
    new StringListContains(CONNECTIONS),
    new StringListContainsAll(CONNECTIONS),
    new Not(new StringListContains(CONNECTIONS)),
    new Not(new StringListContainsAll(CONNECTIONS)),
  ];
  dataEntryComponent = ConnectionsOptionsComponent;
  displayService = ConnectionsOptionsDisplayService;
  label = 'AUTOMATIONS.EDITOR.FILTERS.CONNECTIONS_DATA.CONNECTIONS';
  comparisonLabels = [
    'AUTOMATIONS.EDITOR.FILTERS.CONNECTIONS_DATA.INCLUDES_ANY',
    'AUTOMATIONS.EDITOR.FILTERS.CONNECTIONS_DATA.INCLUDES_ALL',
    'AUTOMATIONS.EDITOR.FILTERS.CONNECTIONS_DATA.DOES_NOT_INCLUDE_ANY',
    'AUTOMATIONS.EDITOR.FILTERS.CONNECTIONS_DATA.DOES_NOT_INCLUDE_ALL',
  ];
}

export const BUSINESS_APP_DATA_COMPONENTS: Map<string, DataFilter> = new Map<string, DataFilter>([
  [CONNECTIONS, new ConnectionsDataFilter()],
]);
